// Some charges carry a nested Court entry that stashes its own copy of the linked Loan
// movement at charges[].court[].inmateTracking[0] (mirroring how ScheduledEvents does the
// same thing — see scheduledEventMovementAutoCreate.js's syncScheduledEventsInmateTracking).
// A Housing & Tracking edit (e.g. marking that Loan movement Complete) only ever touches the
// flat bookings.inmateTracking[] array — it never updates this nested copy. Left unsynced,
// both copies of the same InmateTrackingID ride along in the same save payload and whichever
// collection the API writes last wins, so the nested stale snapshot can silently overwrite
// the status/dates the user just changed. This keeps the nested copy in lock-step with the
// flat array (the authoritative source) right before the payload is sent. Returns a
// (possibly-unchanged) charges array.
export const syncChargesCourtInmateTracking = (finalBookings) => {
  const charges = finalBookings?.charges;
  if (!charges?.length) return charges;

  const trackingByID = new Map(
    (finalBookings?.inmateTracking || [])
      .filter((t) => t?.inmateTrackingID)
      .map((t) => [t.inmateTrackingID, t]),
  );
  if (!trackingByID.size) return charges;

  let changed = false;
  const syncedCharges = charges.map((charge) => {
    const courtEntries = charge?.court;
    if (!courtEntries?.length) return charge;

    let courtChanged = false;
    const syncedCourt = courtEntries.map((c) => {
      const linked = c?.inmateTracking?.[0];
      const current = linked?.inmateTrackingID
        ? trackingByID.get(linked.inmateTrackingID)
        : null;
      if (!current || current === linked) return c;
      courtChanged = true;
      return { ...c, inmateTracking: [{ ...linked, ...current }] };
    });

    if (!courtChanged) return charge;
    changed = true;
    return { ...charge, court: syncedCourt };
  });

  return changed ? syncedCharges : charges;
};
